
document.addEventListener("DOMContentLoaded", function () {
    console.log("Pop-up script loaded.");

    const freeShippingThreshold = 350; // Free shipping threshold

    function updateShippingMessage() {
        console.log("Updating shipping message...");

        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                let cartTotal = cart.total_price / 100; // Convert cents to dollars
                console.log("Cart total: $" + cartTotal);

                // Remove any existing pop-ups before creating a new one (fix mobile issue)
                document.querySelectorAll("#free-shipping-popup").forEach(popup => {
                    console.log("Removing old pop-up instance.");
                    popup.remove();
                });

                // Create new pop-up
                let popup = document.createElement("div");
                popup.id = "free-shipping-popup";
                popup.className = "free-shipping-popup";
                popup.style.position = "fixed";
                popup.style.top = "50%";
                popup.style.left = "50%";
                popup.style.transform = "translate(-50%, -50%)";
                popup.style.padding = "15px";
                popup.style.backgroundColor = "#69B9B2"; // Updated color
                popup.style.color = "#fff";
                popup.style.borderRadius = "10px";
                popup.style.zIndex = "10000";
                popup.style.textAlign = "center";
                popup.style.fontSize = "16px";
                popup.style.fontWeight = "bold";
                popup.style.display = "block";
                popup.style.width = "80%";
                popup.style.maxWidth = "300px";
                popup.style.boxShadow = "0px 4px 10px rgba(0, 0, 0, 0.2)";

                if (cart.item_count === 0) {
                    console.log("Cart is empty. Pop-up will not be displayed.");
                    return;
                }

                let remainingAmount = freeShippingThreshold - cartTotal;
                let message = remainingAmount > 0 
                    ? `You're just $${remainingAmount.toFixed(2)} away from Free Shipping!`
                    : "🎉 Congratulations! You qualify for Free Shipping! 🎉";

                popup.innerText = message;
                document.body.appendChild(popup);
                console.log("Pop-up displayed:", message);

                // Ensure pop-up disappears after 4 seconds
                setTimeout(() => {
                    console.log("Hiding pop-up after 4 seconds.");
                    popup.style.display = "none";
                    popup.remove();
                }, 4000);
            })
            .catch(error => console.error("Error fetching cart:", error));
    }

    // Detect when a product is added to the cart and show the pop-up again
    document.addEventListener("click", function (event) {
        if (event.target.closest("form[action*='/cart/add']")) {
            console.log("Product added to cart! Triggering pop-up.");
            setTimeout(updateShippingMessage, 2000); // Delay to allow cart update
        }
    });

    // Update pop-up on cart updates
    document.addEventListener("cart:updated", function() {
        console.log("Cart updated event detected. Showing pop-up again.");
        updateShippingMessage();
    });

    updateShippingMessage(); // Initial load
});
